<template>
  <div>
    <template v-if="!isAllowed">
      <empty-space />
      <h2>Access denied</h2>
      <p>You are not allowed to see this data.</p>
    </template>
    <template v-if="isAllowed">
      <template v-if="isReadOnly()">
        <empty-space />
        <v-alert color="notice">You have ready only permission on this section.</v-alert>
      </template>
      <slot></slot>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import EmptySpace from '@/components/EmptySpace'
  import PermissionsMixin from '@/mixins/Permissions'
  export default {
    name: 'PermissionsView',
    mixins: [
      PermissionsMixin,
    ],
    components: { EmptySpace },
    props: ['site', 'section'],
    computed: {
      ...mapState({
        user: state => state.user.data,
        permissions: state => state.user.data.permissions,
      }),
      isAllowed () {
        const siteKey = 'site-' + this.site.id
        // allow everything on one specific site
        if (this.permissions[siteKey] && this.permissions[siteKey]['*'] && this.permissions[siteKey]['*'].view) {
          return true
        }
        // allow some things on one specific site
        if (this.permissions[siteKey] && this.permissions[siteKey][this.section] && this.permissions[siteKey][this.section].view) {
          return true
        }
        // allow everything
        if (this.permissions['site-*'] && this.permissions['site-*']['*'] && this.permissions['site-*']['*'].view) {
          return true
        }
        // allow something on all sites
        if (this.permissions['site-*'] && this.permissions['site-*'][this.section] && this.permissions['site-*'][this.section].view) {
          return true
        }
        return false
      },
    },
  }
</script>

<style scoped>

</style>
